import React from 'react'
import ReactDOM from 'react-dom/client'
import MobilePayPage from './pages/MobilePayPage'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MobilePayPage />
  </React.StrictMode>,
)
